import { ctaButton } from '@/modules/parts/ctaButton';
import { preventFullscreen } from '@/modules/actions/preventFullscreen';

let _disablePreserve3DInjected = false;

export const createSlide = (content) => {
    // iPhone のときのみ、3D キューブの preserve-3d を無効化
    if (window.isIphone && !_disablePreserve3DInjected) {
      _disablePreserve3DInjected = true;
      const s = document.createElement('style');
      s.id = 'disable-preserve-3d';
      s.textContent = `
        .swiper-3d .swiper-slide,
        .swiper-3d .swiper-cube-shadow {
          transform-style: initial !important;
        }
      `;
      document.head.appendChild(s);
    }
    const slide = document.createElement('div');
    slide.className = 'storeeel-swiper-group-wrapper swiper-slide';
    if (window.storeeelItems.isMobile) {
      slide.style.height = '100dvh';
      slide.style.background = '#000';
      slide.style.inset = '0';
      slide.style.margin = '0';
      slide.style.padding = '0';
    }

    // モバイルかつcircleでない場合のみ、slide の高さを 100dvh に固定
    if (window.storeeelItems.isMobile && window.storeeelItems.frame !== 'circle') {
      slide.style.height = '100dvh';
    }

    const asset = content.mediaAsset;
    const isImage = asset.attachmentData.metadata.mime_type.includes('image');

    const mediaEl = isImage ? document.createElement('img') : document.createElement('video');
    mediaEl.className = isImage ? 'storeeel-media-image' : 'storeeel-movie';
    mediaEl.classList.add('active');
    mediaEl.setAttribute('media-name', asset.name);
    mediaEl.setAttribute('media-id', asset.id);
    mediaEl.setAttribute('group-id', content.contentGroupId);
    mediaEl.src = asset.mediaUrl;

    if (!isImage) {
      // SP時にうまく動作しない処理のために追加
      // モバイルでフルスクリーンを防ぎ、インライン再生を有効化
           // iPhone のときのみ全画面抑制を実施
          if (window.isIphone) {
             preventFullscreen(mediaEl);
           }
           // 既存の属性設定
           mediaEl.setAttribute('playsinline', '');
           mediaEl.setAttribute('webkit-playsinline', '');
           mediaEl.autoplay = true;
           mediaEl.setAttribute('muted', '');
           mediaEl.muted = true;
         mediaEl.style.transform = 'translateZ(0)';
         mediaEl.style.backfaceVisibility = 'hidden';
          mediaEl.pause();
    }

    // 💡 PC/SP 分岐
    if (window.storeeelItems.isMobile) {
      if (window.isIphone) {
        // SP＋iPhone のときは画像を縦幅いっぱいにカバー
        mediaEl.style.height = '100dvh';
        mediaEl.style.objectFit = 'cover';
      }
      mediaEl.style.width = '100%';
      // メディア要素を下揃えにする
      mediaEl.style.verticalAlign = 'bottom';
    } else {
      mediaEl.style.width = '100%';
      mediaEl.style.height = 'auto';
      mediaEl.style.bottom = isImage ? '2%' : '4%';
      // PC時のメディア要素に角丸を適用
      mediaEl.style.borderRadius = '30px';
      // メディア要素を下揃えにする
      mediaEl.style.verticalAlign = 'bottom';
    }

    // 2025-05-03: 拡大縮小用のラッパー要素を追加
    const wrapper = document.createElement('div');
    wrapper.className = 'slide-media-wrapper';
    wrapper.style.background = '#000';
    // PC のときのみ角丸を適用
    if (!window.storeeelItems.isMobile) {
      wrapper.style.borderRadius = '30px';
    }
    wrapper.style.setProperty('-webkit-tap-highlight-color', 'transparent');
    wrapper.appendChild(mediaEl);

    // wrapperにグループIDを設定
    wrapper.setAttribute('group-id', content.contentGroupId);

    // SP＋circle、SP＋square、PC＋square フレーム時にCTAボタンを付与
    if (
      window.storeeelItems.frame === 'square' ||
      (window.storeeelItems.isMobile && window.storeeelItems.frame === 'circle')
    ) {
      const temp = document.createElement('div');
      temp.innerHTML = ctaButton(content.ctaText || '');
      const styleTag = temp.querySelector('style');
      const ctaFrame = temp.querySelector('.ctaFrame');

      if (styleTag) document.head.appendChild(styleTag);
      if (ctaFrame) wrapper.appendChild(ctaFrame);
      if (window.storeeelItems.isMobile && window.isIphone && ctaFrame) {
        // SP＋iPhone のときはCTAの位置を少し下げる
        ctaFrame.style.bottom = '10%';
      }
    }

    slide.appendChild(wrapper);

    return slide;
  };
